import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  gridFilteredSortedRowIdsSelector,
} from "@mui/x-data-grid-premium";
import { logUserActivity } from "../utils/logger";
import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { useApi } from "../utils/Api";
import Translate from "../utils/Translate";
import DownloadIcon from "@mui/icons-material/Download";

// csv i sverige är inte kommaseparerad, utan semikolonseparerad
const delimiter = localStorage.lang === "29" ? ";" : ",";

export const ToolBar = ({ showExport, hideFilter, exportFileName, apiRef, wide }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const api = useApi();

  const exceljsPreProcess =
    (sheetName) =>
    ({ workbook, worksheet }) => {
      if (sheetName) worksheet.name = sheetName;
      // landscape borde väl vara bra till det mesta
      worksheet.pageSetup = { ...worksheet.pageSetup, orientation: "landscape" };
    };

  const exceljsPostProcess = ({ workbook, worksheet }) => {
    // byt ut exceljs default datumformat till iso format
    for (let i = 0; i < worksheet.columnCount; i++) {
      const columnStyle = worksheet.columns[i].style;
      if (columnStyle.numFmt === "dd.mm.yyyy") {
        for (let j = 1; j < worksheet.rowCount; j++) {
          const cell = worksheet.getRow(j).getCell(i + 1);
          let style = cell.style;
          cell.style = { ...style, numFmt: "yyyy-MM-dd" };
        }
      }
    }

    // streck under första raden
    const firstRow = worksheet.getRow(1);
    firstRow.border = {
      bottom: { style: "thick" },
    };

    // frys första raden
    worksheet.views = [{ state: "frozen", ySplit: 1 }];

    // lägg på autofilter på första raden
    worksheet.autoFilter = {
      from: { row: 1, column: 1 },
      to: { row: worksheet.rowCount, column: worksheet.columnCount },
    };
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleExport = (type) => {
    const filterModel = apiRef.current?.state?.filter?.filterModel;
    const filteredRowIds = gridFilteredSortedRowIdsSelector(apiRef.current.state);
    const nbrOfRows = filteredRowIds.length;

    logUserActivity(type, filterModel, nbrOfRows, api);

    if (type === "csv") {
      apiRef.current.exportDataAsCsv({
        fileName: exportFileName,
        delimiter: delimiter,
        utf8WithBom: true,
        allColumns: true,
      });
    } else if (type === "excel") {
      apiRef.current.exportDataAsExcel({
        fileName: exportFileName,
        allColumns: true,
        exceljsPreProcess: exceljsPreProcess(exportFileName),
        exceljsPostProcess,
      });
    } else if (type === "print") {
      apiRef.current.exportDataAsPrint({
        fileName: exportFileName,
        allColumns: true,
      });
    }

    handleMenuClose();
  };

  return (
    <GridToolbarContainer className={`customToolBar${wide ? " wide" : ""}`}>
      <GridToolbarColumnsButton />
      {!hideFilter && <GridToolbarFilterButton />}
      <GridToolbarDensitySelector />
      {showExport && (
        <>
          <Button onClick={handleMenuClick} variant="text" startIcon={<DownloadIcon />} sx={{ fontSize: "13px" }}>
            {Translate.get("Export")}
          </Button>
          <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
            <MenuItem onClick={() => handleExport("csv")}>{Translate.get("DownloadCsv")}</MenuItem>
            <MenuItem onClick={() => handleExport("excel")}>{Translate.get("DownloadExcel")}</MenuItem>
            <MenuItem onClick={() => handleExport("print")}>{Translate.get("Print")}</MenuItem>
          </Menu>
        </>
      )}
    </GridToolbarContainer>
  );
};
